module.exports = __webpack_public_path__ + "img/7095118.png";